import { Title, TitleProps } from '@mantine/core';

type Props = TitleProps;

function Body1(props: Props) {
  return <Title fz={16} fs="normal" fw={400} {...props} />;
}

export default Body1;
